import { Operation } from './types';

export const DEFAULT_HOOKS: Operation[] = ['activate', 'mount', 'update'];
